import * as React from 'react';
import { Bem, addClass } from '../../utils';
import { useId } from '../../utils/hooks/useId';
import './Anchor.css';
const bem = Bem.create('vai-anchor');
export const Anchor = (props) => {
    const { htmlId, fontSize, openInNewWindow, dataTa, to, children, tabIndex } = props;
    const id = useId(htmlId, ['anchor']);
    const target = openInNewWindow ? '_blank' : '_self';
    const rel = openInNewWindow ? 'noopener' : '';
    const conditionalProps = {
        rel,
        target,
        tabIndex,
        'data-ta': dataTa,
    };
    const onClick = (e) => {
        const { preventDefault } = props;
        if (preventDefault) {
            e.preventDefault();
        }
        if (props.onClick) {
            props.onClick(e);
        }
    };
    const className = addClass(bem.block(fontSize && `font-size-${fontSize}`), props.className);
    return (React.createElement("a", Object.assign({ id: id.toString(), className: className, href: to, onClick: onClick }, conditionalProps), children));
};
//# sourceMappingURL=Anchor.js.map